<template>
	<div>
		
		<div class="row" v-if="cas=='normal'">
			<div class="col-4 offset-4">				
				<p class="text-center">Enter a ensemblID, uniprotID or gene name to search a gene</p>
				<multiselect :label="searchLabel" v-model="search_gene" placeholder="Ensembl ID or Symbol" :options="proposed_genes" :max-height="600" @select="routeUpdate" @search-change="getGeneNames">
					<span slot="noOptions">Ensembl ID or Symbol</span>
					<span slot="noResult">No gene found</span>
					<template slot="option" slot-scope="props"><small>[{{props.option.ensemblID}}]</small> - {{props.option.gene_name}}</template>
				</multiselect>
				<button class="btn btn-link btn-sm" @click="routeUpdate({ensemblID:'ENSMUSG00000028849'})">Example</button>
			</div>			
		</div>
		<multiselect v-if="cas=='light'" :label="searchLabel" v-model="search_gene" placeholder="Ensembl ID or Symbol" :options="proposed_genes" :max-height="600" @select="routeUpdate" @search-change="getGeneNames">
			<span slot="noOptions">Ensembl ID or Symbol</span>
			<span slot="noResult">No gene found</span>
			<template slot="option" slot-scope="props"><small>[{{props.option.ensemblID}}]</small> - {{props.option.gene_name}}</template>
		</multiselect>

	</div>
	
	

</template>

<script>	
import {HTTP} from '@/router/http';
import {siteTitle} from '@/app_config';
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect'

export default {
	name: 'GeneSearch',
	props:['from'],
	components:{Multiselect},
	data () {
		return {
			cas:'normal',
			searchLabel:'concat',
			search_gene:null,
			showNoResult:false,
			loading:false,
			timeoutSearchSymbol:null,
			proposed_genes:[],
		}
	},
	computed:{
		...mapGetters({
			currentUser: 'currentUser',
			// proposed_genes:'proposed_genes',
			gene:'current_gene'
		}),
	},
	methods:{
		getGeneNames(symbol){
			let _this = this;
			_this.geneNames = [];
			_this.showNoResult = false;
			// _this.searchLabel = (symbol.startsWith('ENS')) ? 'ensemblID' : 'symbol';
			if (symbol && symbol.length>1){
				if (_this.timeoutSearchSymbol) { clearTimeout(_this.timeoutSearchSymbol) }
				_this.timeoutSearchSymbol = setTimeout(() => {
					_this.$store.dispatch('getGenes',{symbol:symbol,format:_this.searchLabel}).then(data => {
						// _this.showNoResult = true;
						// _this.proposed_genes = _this.fake;
						_this.proposed_genes = data;
					})
					.catch(err => { _this.$snotify.error("Sorry an error occured: "+err) })

				});
			}
		},
		routeUpdate(obj){
			let _this = this;
			console.info(obj,_this.search_gene);
			_this.loading = true;
			let query = (obj && obj.ensemblID) ? obj.ensemblID: '';
			console.info(_this.$router);
			_this.$store.dispatch('resetGene');
			// _this.search_gene.concat = '';
			// _this.searchLabel = 'bla';
			_this.$router.push("/gene/"+query);
			// _this.proposed_genes = [];

		},
	},
  beforeDestroy() {
		console.info("bef destroy");
		let _this = this;
		_this.search_gene = null;
		_this.proposed_genes = [];
  },
	mounted() {
		var _this = this;
		if (_this.from=='nav') _this.cas = 'light';
	}
}
</script>

// <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
	font-weight: normal;
}
.light-list-group > .list-group-item{
	padding:0px 10px 5px 0;
	border:none;
}

a {
	color: #42b983;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
